import MeterConsumption from './MeterConsumption.yaml?component';
import UcMeterConsumptions from './UcMeterConsumptions.yaml?component';

export { MeterConsumption, UcMeterConsumptions };
